export default __webpack_public_path__ + "static/media/README.10e77288.md";